import React from 'react'
import api, { METHODS } from './api'
import { DuplicateReport } from '../common/types/api/report'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function duplicateReports(uid: string, newTitle: string): Promise<DuplicateReport> {
    try {
        const res = await api<DuplicateReport>(`duplicate/${uid}`, METHODS.POST, newTitle)
        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to duplicate Report: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        }else {
            GlobalNotification.success(<Notification title={i18n('Report duplicated successfully!')} />, 20)
        }

        return res
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to duplicate Report: ')}>
                <tr>
                    <strong>Report uid: </strong> {uid}
                </tr>
                {error}
            </Notification>,
            20
        )

        console.error(error)

        return null
    }
}
